
// Automatically sorts blog elements by their order property
export const methodReorderBlogElements = async (model_blog: Blog) => {
  if (!model_blog || !model_blog.elements) {
    return;
  }

  await nextTick()


  if (!model_blog?.elements) {
    return;
  }

  model_blog.elements
    .sort((a, b) => a.order - b.order)
    .filter(e => !e.inside)
    .forEach((e, i) => {
      e.order = i + 1;
    });

  // sort all with same inside internaly .filter(e => e.inside === model.value?.unique)
  const insides = model_blog.elements.reduce((acc: string[], e) => {
    if (!acc.includes(e.inside) && e.inside) {
      acc.push(e.inside);
    }
    return acc;
  }, [])

  insides.forEach((inside) => {
    model_blog.elements?.filter(e => e.inside === inside)
      .sort((a, b) => a.order - b.order)
      .forEach((e, i) => {
        e.order = i + 1;
      });
  })
}

export const methodMoveElement = async (model_blog: Blog, element: BlogElement, up: boolean) => {
  console.log('Moving element:', element, 'up:', up);

  return await methodReorderBlogElements(model_blog).then(() => {
    if (!model_blog || !model_blog.elements) {
      return;
    }

    model_blog.elements.filter(e => e.unique === element.unique)
      .forEach((e) => {
        if (!model_blog.elements) {
          return;
        }

        e.order = up
          ? e.order - 1.6
          : e.order + 1.5;

        console.log('New order for element:', e.order);
      });

    setTimeout(() => {
      methodReorderBlogElements(model_blog)
    }, 50)
  })
}

export const methodRemoveElement = async (model_blog: Blog, element: BlogElement) => {
  console.log('Removing element:', element);

  if (!model_blog || !model_blog.elements) {
    return;
  }

  model_blog.elements = model_blog.elements.filter(e => e.unique !== element.unique);

  await methodReorderBlogElements(model_blog);
}

export const methodInsertElement = async (model_blog: Blog, dragging_unique: string, nextto_unique:string, above: boolean) => {
  if (!model_blog || !model_blog.elements) {
    console.error('Model blog or elements not found');
    return;
  }

  const draggingElement = model_blog.elements.find(e => e.unique === dragging_unique);
  const nextElement = model_blog.elements.find(e => e.unique === nextto_unique);

  if (!draggingElement || !nextElement) {
    console.error('Element to insert or below not found');
    return;
  }

  draggingElement.inside = nextElement?.inside;
  draggingElement.order = nextElement?.order + ((above) ? 0.2 : -0.6);

  methodReorderBlogElements(model_blog);
}

export const methodAddElement = async (model_blog: Blog, element: BlogElement, up: boolean) => {
  console.log('Adding element:', element, 'up:', up);

  if (!model_blog || !model_blog.elements) {
    return;
  }

  const newElement: BlogElement = {
    id: crypto.randomUUID(),
    unique: crypto.randomUUID(),
    content: 'I am a new element',
    type: 'paragraph',
    order: up
      ? (element.order - 0.5)
      : (element.order + 0.5),
    meta: {
      i18n: {
        en: {},
        de: {},
        at: {},
        es: {},
        uk: {},
        ru: {},
      },
    },
    inside: element.inside || '',
  };

  model_blog.elements.push(newElement);

  nextTick(() => {
    methodInsertElement(model_blog, newElement.unique, element.unique, up);
  });

  // await methodReorderBlogElements(model_blog);
}
